export default __webpack_public_path__ + "static/media/design.b489d3c2.jpg";